// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Josh's Custom CSS Reset
  https://www.joshwcomeau.com/css/custom-css-reset/
*/

*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  margin: 0;
}

@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}

body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

img,
picture,
video,
canvas,
svg {
  display: block;
  max-width: 100%;
}

input,
button,
textarea,
select {
  font: inherit;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

p {
  text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  text-wrap: balance;
}

#root,
#__next {
  isolation: isolate;
}

/*--------- page style ----------*/

body {
  min-height: 100vh;
  min-width: 100vw;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

main {
  min-height: 70%;
  min-width: 70%;
  display: flex;

  justify-content: center;
  align-items: center;
  gap: 5rem;
}

main button {
  background: none;
}

#human-player,
#computer-player {
  height: 45vh;
  width: 45vh;

  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: repeat(10, 1fr);
}

#human-player button,
#computer-player button {
  border: 1px solid black;
  cursor: pointer;
}

#human-player button[data-row="0"],
#computer-player button[data-row="0"] {
  border-top: 4px solid black;
}

#human-player button[data-column="0"],
#computer-player button[data-column="0"] {
  border-left: 4px solid black;
}

#human-player button[data-row="9"],
#computer-player button[data-row="9"] {
  border-bottom: 4px solid black;
}

#human-player button[data-column="9"],
#computer-player button[data-column="9"] {
  border-right: 4px solid black;
}

#human-player > button:nth-child(1),
#computer-player button:nth-child(1) {
  border-top-left-radius: 0.8rem;
}

#human-player > button:nth-child(10),
#computer-player button:nth-child(10) {
  border-top-right-radius: 0.8rem;
}

#human-player > button:nth-child(91),
#computer-player button:nth-child(91) {
  border-bottom-left-radius: 0.8rem;
}

#human-player > button:nth-child(100),
#computer-player button:nth-child(100) {
  border-bottom-right-radius: 0.8rem;
}

main button:hover,
main button:hover {
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
}

#human-player button.ship {
  background-color: blue;
}

#human-player button.ship.hit  {
  background-color: lightcoral;
}


button.ship:hover {
  background-color: none;
}

button.hit {
  color: red;
  font-size: 100%;
  font-weight: 900;
}

button.ship.hit {
  background-color: lightcoral;
}

#fleet {
  margin-top: 5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

#fleet > div{
  background-color: crimson;
  display: flex;
}

#fleet > div > div{
  border: 2px solid coral;
  flex-grow: 1;
}

#carrier {
  min-height: 2rem;
  min-width: 11vw;
}

#battleship {
  min-height: 2rem;
  min-width: 9vw;
}

#cruiser,
#submarine {
  height: 2rem;
  width: 7vw;
}

#destroyer {
  height: 2rem;
  width: 5vw;
}

#human-player .preview {
  background-color: green;
}

#human-player .invalid {
  background-color: red;
}

.winner {
  margin-top: 5rem;
  padding: 2rem;
  border: 2px solid green;
  font-size: 2rem;
  font-weight: 700;
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;;EAKE,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;AACA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,kCAAkC;;AAElC;EACE,iBAAiB;EACjB,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;;EAEb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,WAAW;;EAEX,aAAa;EACb,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE;;gDAE8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B","sourcesContent":["/*\n  Josh's Custom CSS Reset\n  https://www.joshwcomeau.com/css/custom-css-reset/\n*/\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n\nbody {\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n}\n\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n  display: block;\n  max-width: 100%;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\np {\n  text-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-wrap: balance;\n}\n\n#root,\n#__next {\n  isolation: isolate;\n}\n\n/*--------- page style ----------*/\n\nbody {\n  min-height: 100vh;\n  min-width: 100vw;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\nmain {\n  min-height: 70%;\n  min-width: 70%;\n  display: flex;\n\n  justify-content: center;\n  align-items: center;\n  gap: 5rem;\n}\n\nmain button {\n  background: none;\n}\n\n#human-player,\n#computer-player {\n  height: 45vh;\n  width: 45vh;\n\n  display: grid;\n  grid-template-columns: repeat(10, 1fr);\n  grid-template-rows: repeat(10, 1fr);\n}\n\n#human-player button,\n#computer-player button {\n  border: 1px solid black;\n  cursor: pointer;\n}\n\n#human-player button[data-row=\"0\"],\n#computer-player button[data-row=\"0\"] {\n  border-top: 4px solid black;\n}\n\n#human-player button[data-column=\"0\"],\n#computer-player button[data-column=\"0\"] {\n  border-left: 4px solid black;\n}\n\n#human-player button[data-row=\"9\"],\n#computer-player button[data-row=\"9\"] {\n  border-bottom: 4px solid black;\n}\n\n#human-player button[data-column=\"9\"],\n#computer-player button[data-column=\"9\"] {\n  border-right: 4px solid black;\n}\n\n#human-player > button:nth-child(1),\n#computer-player button:nth-child(1) {\n  border-top-left-radius: 0.8rem;\n}\n\n#human-player > button:nth-child(10),\n#computer-player button:nth-child(10) {\n  border-top-right-radius: 0.8rem;\n}\n\n#human-player > button:nth-child(91),\n#computer-player button:nth-child(91) {\n  border-bottom-left-radius: 0.8rem;\n}\n\n#human-player > button:nth-child(100),\n#computer-player button:nth-child(100) {\n  border-bottom-right-radius: 0.8rem;\n}\n\nmain button:hover,\nmain button:hover {\n  box-shadow:\n    rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,\n    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;\n}\n\n#human-player button.ship {\n  background-color: blue;\n}\n\n#human-player button.ship.hit  {\n  background-color: lightcoral;\n}\n\n\nbutton.ship:hover {\n  background-color: none;\n}\n\nbutton.hit {\n  color: red;\n  font-size: 100%;\n  font-weight: 900;\n}\n\nbutton.ship.hit {\n  background-color: lightcoral;\n}\n\n#fleet {\n  margin-top: 5rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n#fleet > div{\n  background-color: crimson;\n  display: flex;\n}\n\n#fleet > div > div{\n  border: 2px solid coral;\n  flex-grow: 1;\n}\n\n#carrier {\n  min-height: 2rem;\n  min-width: 11vw;\n}\n\n#battleship {\n  min-height: 2rem;\n  min-width: 9vw;\n}\n\n#cruiser,\n#submarine {\n  height: 2rem;\n  width: 7vw;\n}\n\n#destroyer {\n  height: 2rem;\n  width: 5vw;\n}\n\n#human-player .preview {\n  background-color: green;\n}\n\n#human-player .invalid {\n  background-color: red;\n}\n\n.winner {\n  margin-top: 5rem;\n  padding: 2rem;\n  border: 2px solid green;\n  font-size: 2rem;\n  font-weight: 700;\n  text-transform: capitalize;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
